import { getUtmParams } from './utm';
import { track } from './track';

// Client-side analytics. Every send goes through track() (./track.js), which
// swallows failures — Firebase Analytics only exists if googletagmanager.com
// loaded, and an ad blocker leaves `analytics` undefined so a bare logEvent
// throws. These used to call logEvent directly, so that throw propagated into
// whichever render path invoked them.

// Track a page view with UTM attribution.
export function trackPageView() {
  const utmParams = getUtmParams();

  track('page_view', {
    page_title: document.title,
    page_location: window.location.href,
    page_path: window.location.pathname,
    ...utmParams,
  });

  // Landing from a QR code.
  if (utmParams.utm_source === 'qrcode') {
    track('qr_code_scan', { ...utmParams });
  }

  // Persist UTMs for attribution across the session.
  if (Object.keys(utmParams).length > 0) {
    try {
      sessionStorage.setItem('utm_params', JSON.stringify(utmParams));
    } catch (_err) {
      // Safari private mode throws on sessionStorage writes.
    }
  }
}

// Generic event with UTM attribution. track() merges the stored UTMs.
export function trackEvent(eventName, eventParams = {}) {
  return track(eventName, eventParams);
}

// First-touch attribution on app mount. Moved here from the deleted
// analytics/conversations.js, which was body-scan-era code: every other
// tracker in that file (trackAccountCreation, trackOnboardingComplete,
// trackScanCreation, trackPostCreation, trackExerciseCreation, trackLead) had
// ZERO call sites, and two of them referenced features Lane C removed. That is
// why GA4 recorded 2 `account_creation` events against 707 real signups — the
// funnel was never instrumented, not mis-instrumented.
//
// The replacements are server-side (functions/contracts/analytics.js EVENTS),
// which cannot be forgotten at a call site or blocked by an ad blocker.
export function trackSiteVisit(source = 'direct', referrer = null) {
  return track('site_visit', {
    visit_source: source,
    referrer: referrer || document.referrer || 'none',
    timestamp: new Date().toISOString(),
    ...getUtmParams(),
  });
}